<template>
  <section class="layout">
    <!-- 缓冲 -->
    <router-view v-slot="{ Component, route }">
      <transition
        name="fade"
        mode="out-in"
        :css="!route.meta.noAppear"
        :appear="!route.meta.noAppear"
      >
        <keep-alive v-if="$route.meta.isCached">
          <component :is="Component"></component>
        </keep-alive>
        <!-- 无缓冲 -->
        <div v-else>
          <component :is="Component"></component>
        </div>
      </transition>
    </router-view>
    <el-backtop :right="100" :bottom="280" />
  </section>
</template>
<script lang="ts" setup>
import { useUserStore } from '@/store/modules/user'
import { useAppStore } from '@/store/modules/app'
// import { useCssVar } from '@vueuse/core'

const userStore = useUserStore()
const appStore = useAppStore()

watchEffect(() => {
  const token = userStore.getToken
  const userInfo = userStore.getUserInfo
  //已经登录，但没有用户信息时，重新请求
  if (token && !userInfo) {
    // userStore.initUserInfo()
  }
})
</script>
<style lang="scss" scoped>
html,
body,
#app,
.layout {
  overflow-x: hidden;
  width: 100%;
  height: 100%;
  div {
    width: 100%;
    height: 100%;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: all 2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
